import React, {useEffect, useState} from 'react';

import './styles.scss';
import Icon from '../icon';
import {Icons} from '../../util/icons';
import colors from '../../util/colors';
import {createClassName} from '../../util/utility';
import {Column, Row} from '../layout';
import AppButton from '../app-button';
import * as fonts from '../../util/fonts';
import Statusbar from '../status-bar/statusBar';
import {Progress} from 'antd';
import backgroundImage from '../../assets/advance-care-plus/image_advacare.png';
import logoImage from '../../assets/advance-care-plus/advcare+logo.png';
import logoImageResponsive from '../../assets/advance-care-plus/advCare_Logo.png';

import 'antd/dist/antd.css';
import {strings} from '../../util/strings';
import {addToGlobalStyles, addToWizard} from '../../store/actions';
import {compose} from 'redux';
import {connect} from 'react-redux';
// import {uriGetHealthScore} from '../../api/endpoints';
// import {get} from '../../api/api';

interface AdvanceCarePlusProps {
  labels: typeof strings.pt.healthScore;
  user: any;
  healthScore: any;
}

function AdvanceCarePlus({labels, user, healthScore}: AdvanceCarePlusProps) {
  switch (healthScore.status) {
    case 'ACTIVE':
      if (!!healthScore.healthScore) {
        return (
          <Column>
            <Row className="logo-image justify-content-center mb-3">
              <Column>
                <img
                  className="logo-image-title"
                  src={logoImage}
                  width={200}></img>
                <Row className="justify-content-center mb-0">
                  <p className="mb-0" style={{...fonts.M, color: colors.black}}>
                    {labels?.healthScore_myScore}
                  </p>
                </Row>
              </Column>
            </Row>
            <Row className="dashboard-info-row p-0">
              <Column className="dashboard-column col-5">
                <Progress
                  type="dashboard"
                  // showInfo={false}
                  percent={healthScore.healthScore.healthScoreValue / 10}
                  gapDegree={140}
                  width={250}
                  strokeColor={{
                    '0%': colors.darkBlue,

                    '100%': colors.lightBlue,
                  }}
                  format={() => (
                    <Column className="info-of-circle-graph">
                      <img src={logoImageResponsive} width={30}></img>
                      <Row className="pt-2">
                        <a href={labels?.healthScore_link} target="_blank">
                          <p
                            className="mb-0"
                            style={{
                              ...fonts.XL,
                              color: colors.fluorescentBlue,
                              fontWeight: 'bold',
                            }}>
                            {healthScore.healthScore.healthScoreValue}
                          </p>
                        </a>
                      </Row>
                      <Row>
                        <p
                          style={{
                            ...fonts.M,
                            color: colors.black,
                            fontWeight: 'bold',
                          }}>
                          {healthScore.healthScore.healthScoreDescription}
                        </p>
                      </Row>
                    </Column>
                  )}></Progress>
              </Column>
              <Column className="col-of-progressbars col-7 pt-5">
                <Row className="mb-0">
                  <Row className="w-75 mr-4">
                    <p
                      className="mb-0"
                      style={{...fonts.M, color: colors.black}}>
                      {labels?.healthScore_lifestyle}
                    </p>
                  </Row>
                  <Progress
                    strokeColor={{
                      '0%': colors.darkBlue,

                      '100%': colors.lightBlue,
                    }}
                    percent={healthScore.healthScore.lifeStyle / 10}
                    showInfo={false}
                    className=""></Progress>
                  {/* </Row> */}
                </Row>
                <Row className="mb-0">
                  <Row className="w-75 mr-4">
                    <p
                      className="mb-0"
                      style={{...fonts.M, color: colors.black}}>
                      {labels?.healthScore_body}
                    </p>
                  </Row>
                  <Progress
                    strokeColor={{
                      '0%': colors.darkBlue,

                      '100%': colors.lightBlue,
                    }}
                    percent={healthScore.healthScore.body / 10}
                    showInfo={false}
                    className=""></Progress>
                </Row>

                <Row className="mb-0">
                  <Row className="w-75 mr-4">
                    <p
                      className="mb-0"
                      style={{...fonts.M, color: colors.black}}>
                      {labels?.healthScore_emotions}
                    </p>
                  </Row>
                  <Progress
                    strokeColor={{
                      '0%': colors.darkBlue,

                      '100%': colors.lightBlue,
                    }}
                    percent={healthScore.healthScore.feelings / 10}
                    showInfo={false}
                    className=""></Progress>
                </Row>
              </Column>

              {/* RESPONSIVE */}
              <Column className="progressbars-responsive">
                <Row className="progressbars-responsive-row">
                  <Column className="col-4 p-0 m-0">
                    <Progress
                      strokeColor={{
                        '0%': colors.darkBlue,

                        '100%': colors.lightBlue,
                      }}
                      percent={healthScore.healthScore.lifeStyle / 10}
                      showInfo={false}
                      className="pl-1 pr-1"></Progress>
                  </Column>

                  <Column className="col-4 m-0 p-0">
                    <Progress
                      strokeColor={{
                        '0%': colors.darkBlue,

                        '100%': colors.lightBlue,
                      }}
                      percent={healthScore.healthScore.body / 10}
                      showInfo={false}
                      className="pl-1 pr-1"></Progress>
                  </Column>

                  <Column className="col-4 m-0 p-0">
                    <Progress
                      strokeColor={{
                        '0%': colors.darkBlue,

                        '100%': colors.lightBlue,
                      }}
                      percent={healthScore.healthScore.feelings / 10}
                      showInfo={false}
                      className="pl-1 pr-1"></Progress>
                  </Column>
                </Row>

                <Row className="progressbars-responsive-row">
                  <Column className="col-4 p-0">
                    <Row className="justify-content-center">
                      <p
                        className="mb-0"
                        style={{...fonts.SM, color: colors.black}}>
                        {labels?.healthScore_lifestyle}
                      </p>
                    </Row>
                  </Column>
                  <Column className="col-4 p-0">
                    <Row className="justify-content-center">
                      <p
                        className="mb-0"
                        style={{...fonts.SM, color: colors.black}}>
                        {labels?.healthScore_body}
                      </p>
                    </Row>
                  </Column>
                  <Column className="col-4 p-0">
                    <Row className="justify-content-center">
                      <p
                        className="mb-0"
                        style={{...fonts.SM, color: colors.black}}>
                        {labels?.healthScore_emotions}
                      </p>
                    </Row>
                  </Column>
                </Row>
              </Column>
            </Row>
          </Column>
        );
      }
    case 'INACTIVE' || undefined:
      return <div></div>;
    default:
      return (
        <Row className="advance-care-plus-main-row">
          <Column className="test">
            <img src={backgroundImage} width={200}></img>{' '}
          </Column>
          <Column className="advance-care-plus-main-col">
            <Row className="logo-image">
              <img src={logoImage} width={200}></img>
            </Row>
            <Row className="logo-image-responsive">
              <p
                style={{
                  ...fonts.L,
                  color: colors.black,
                  fontWeight: 'bolder',
                }}>
                {labels?.healthScore_advanceCarePlus}
              </p>
              <img src={logoImageResponsive} width={50}></img>
            </Row>

            <Row className="advance-care-plus-text mb-4">
              <Column className="advance-care-plus-subtitle col-8 p-0">
                <p
                  className="advance-care-plus-subtitle-paragraph m-0"
                  style={{
                    ...fonts.ML,
                    color: colors.black,
                    fontWeight: 'bold',
                  }}>
                  {labels?.healthScore_levelOfHealth}
                </p>
              </Column>
            </Row>
            <Row className="advance-care-plus-text-responsive mb-4">
              <Column className="advance-care-plus-subtitle col-8 p-0">
                <p
                  className="advance-care-plus-subtitle-paragraph m-0"
                  style={{
                    ...fonts.ML,
                    color: colors.black,
                    fontWeight: 'bold',
                  }}>
                  {labels?.healthScore_levelOfHealth}
                </p>
              </Column>
            </Row>

            <Row className="advance-care-plus-row-text">
              <Column className="advance-care-plus-text col-8 p-0">
                <p style={{...fonts.M, color: colors.black}}>
                  {labels?.healthScore_joinAdvanceCarePlus}
                </p>
              </Column>
              <Column className="advance-care-plus-text-responsive col-8 p-0">
                <p style={{...fonts.M, color: colors.black}}>
                  {labels?.healthScore_joinAdvanceCarePlus}
                </p>
              </Column>
            </Row>

            <Row className="advance-care-plus-button-row">
              <AppButton className="advance-care-plus-button">
                <a href={labels?.healthScore_link} target="_blank">
                  <p className="mb-0" style={{...fonts.M, color: colors.white}}>
                    {labels?.healthScore_joinNow}
                  </p>
                </a>
              </AppButton>
            </Row>
          </Column>
        </Row>
      );
  }
}

const mapStateToProps = ({strings, wizard, user}: any) => ({
  labels: strings.value.pt.healthScore,
  wizard: wizard.value,
  user: user.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(AdvanceCarePlus),
);
